import React, { useMemo } from 'react';
import { OfferTemplateConfig, TemplatePage } from '../../../../../types/offerTemplate.types';
import BlockRendererFactory from './BlockRendererFactory';

export interface ContentPageRendererProps {
  page: TemplatePage;
  config: OfferTemplateConfig;
}

const A4_WIDTH = 794;
const A4_HEIGHT = 1123;

const ContentPageRenderer: React.FC<ContentPageRendererProps> = ({ page, config }) => {
  const s = page.settings || {};
  const bgColor = typeof s.bgColor === 'string' && s.bgColor ? s.bgColor : '#ffffff';

  const blocks = useMemo(() => {
    const list = page.blocks ?? [];
    return [...list].filter(b => b.visible).sort((a, b) => a.order - b.order);
  }, [page.blocks]);

  const fontStack = `'${config.font}', Arial, sans-serif`;

  return (
    <div
      data-pdf-page="true"
      style={{
        width: A4_WIDTH,
        minHeight: A4_HEIGHT,
        boxSizing: 'border-box',
        backgroundColor: bgColor,
        fontFamily: fontStack,
        fontSize: config.fontBoyutu,
        color: '#333',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ height: 4, backgroundColor: config.aksanRenk, flexShrink: 0 }} />
      <div style={{ padding: 40, flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {blocks.map(block => (
            <BlockRendererFactory key={block.id} block={block} config={config} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentPageRenderer;
